import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';

import { NativeTypes } from 'react-dnd-html5-backend';

import Stack from '@mui/material/Stack';

import { grey } from '@mui/material/colors';
import elements from 'components/elements';

class Dropzone extends Component {
  render() {
    const { onDrop, htmlFor, children, connectDropTarget } = this.props;
    return connectDropTarget(
      <label
        htmlFor={htmlFor}
        onDrop={onDrop}
        style={{ position: 'relative' }}
        data-element={elements.popup.Upload.dropZone}
      >
        <Stack
          spacing={1}
          justifyContent="center"
          alignItems="center"
          border={`1px dashed ${grey[300]}`}
          borderRadius={2}
          py={3}
        >
          {children}
        </Stack>
      </label>,
    );
  }
}

const collect = (connect) => ({
  connectDropTarget: connect.dropTarget(),
});

export default DropTarget([NativeTypes.FILE], {}, collect)(Dropzone);
